const PlusIcon = ({ width = 16, className = '' }: { width?: number; className?: string }) => (
  <svg width={width} height={width} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M8.00004 1.33331V14.6666M14.6667 7.99998L1.33337 7.99998" stroke="var(--s247-primary, #B3446D)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default PlusIcon;
